import { Injectable } from "@angular/core";
import { BaseGridResponse } from "planning-portal-library/src/lib/data/shared/base-grid.response";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { GetServicesRequest } from "../../domain";
import { Service } from "../../domain/models/service";
import { ServicesRepository } from "../../repositories/service.repository";

@Injectable({ providedIn: 'root' })
export class GetServicesUsecase implements UseCase<BaseRequest<GetServicesRequest>,BaseGridResponse<Service>> {

  constructor(private readonly serviceRepository: ServicesRepository) {
  }

  execute(params: BaseRequest<GetServicesRequest>): Observable<BaseGridResponse<Service>> {
    return this.serviceRepository.getServices(params);
  }

}
